module.exports = __webpack_public_path__ + "images/emoji/loop.b351c552c74534df7cbb.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/loop.png
// module id = +ieS
// module chunks = 2